import styled from 'styled-components';

export default styled.div`
  display: inline;
  a {
    margin: 0 5px;
    font-size: 14px;
  }
`;
